import React, { useEffect, useRef, useState } from "react";
import { useLottie } from "lottie-react";
import {
  Box,
  Text
} from '@chakra-ui/react'
import ThankYou from "../../lotties/thanks.json";

export default function ThankYouLottie() {
  const options = {
    animationData: ThankYou,
    loop: false,
  }

  const { View } = useLottie(options);

  return (
    <Box>
      <Box>{View}</Box>
      <Box>
        <Text textAlign="center" mt="-8">
          Thank you for your donation!<br />Please check your email for a receipt.
        </Text>
      </Box>
    </Box>
  )
}
